<template>
	<div>
		<div class="list-btn">
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="details(row)">订单详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '合同编号',
						key: 'contractCode'
					},
					{
						title: '加盟商名称',
						key: 'allianceName'
					},
					{
						title: '金额',
						key: 'money',
						render: (h, params) => {
						    return h("div",params.row.money/100)
						}
					},
					{
						title: '录入人',
						key: 'empName'
						
					},
					{
						title: '设备安装状态',
						key: 'macContractStateName'
						
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10
				},
				
			}
		},
		methods: {
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			
			
			details(row) {
				let _this=this
				this.$router.push({
					name: 'alliance/mac/order/details/list',
					query:{
						id:row.id,
						macContractState:row.macContractState
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/contract/page/alliance',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/macOrder/list.vue